<template>
	<button
		ref="button"
		:class="[{disabled: disabled}, {'disable-box-shadow': disableBoxShadow}, `shape-${shape}`, `button-${appearance}`, intent, size]"
		:disabled="disabled"
		:title="value"
		class="icon-button"
		:tabindex="tabindex"

		@click="onClick"
		@mousedown="onMouseDown"
		@focus="onFocus"
		@blur="onBlur"
		@keydown="onKeydown"
	>
		<t-timpex-icon
			:type="type"
			:icon="icon"
			:size="iconSize"
			:color="color"
			class="icon"
		/>
	</button>
</template>

<script>
import buttonMixin from './buttonMixin.js';
import TTimpexIcon from '../timpex/icons/TTimpexIcon';
export default {
	name: 'TIconButton',
	components: { TTimpexIcon },
	mixins: [buttonMixin],
	props: {
		icon: String,
		type: String,
		color: String,
		value: String,
		disableBoxShadow: Boolean,
		tabindex: {
			type: [Number, String],
			default: 0
		}
	},
};
</script>

<style lang="scss" scoped>
@import './scss/';
.icon-button {
	height: 32px;
	width: 32px;
	padding: 0 !important;
	display: flex;
	justify-content: center;
	align-items: center;
}

.icon {
	pointer-events: none;
}

</style>


<docs>
## Examples

### Icon Button Appearances

```jsx
<div style="display: inline-grid; grid-column-gap: 10px; grid-template-columns: repeat(5, auto);">
	<t-icon-button @click="this.alert('Button clicked')" type="bp" icon="user"></t-icon-button>
	<t-icon-button icon="trash" type="bp" intent="danger"></t-icon-button>
	<t-icon-button icon="user" type="bp" appearance="primary"></t-icon-button>
	<t-icon-button icon="user" type="bp" appearance="minimal"></t-icon-button>
	<t-icon-button icon="user" type="bp" disabled></t-icon-button>
</div>
```
</docs>
